import { hydrateRoot, createRoot } from 'react-dom/client';
import { initTheme } from '@/lib/theme';
import App from './App';
import './index.css';
import { registerWebMcp } from './lib/webmcp';

// Runtime theme (dark default, light via the nav switcher; persisted per visitor).
initTheme();

const container = document.getElementById('root');
if (!container) {
  throw new Error('Failed to find the root element');
}

// Check if we're hydrating SSR content or starting fresh
if (container.hasChildNodes()) {
  // SSR content exists, hydrate it
  hydrateRoot(container, <App />);
} else {
  // No SSR content, render normally (fallback)
  const root = createRoot(container);
  root.render(<App />);
}

// Expose read-only site tools to browser AI agents (WebMCP). No-ops where the
// experimental navigator.modelContext API is unavailable.
registerWebMcp();
